'use client';

import { useMemo } from 'react';

import { ThinkingState } from '@/components/ui/thinking-state-clean';
import type { ChatMessage } from '@/types/chat';

import { buildWorkingSteps, workingTiming } from '../utils/workingSteps';

type Props = {
  message: ChatMessage;
  /** The turn is still streaming. */
  isLive: boolean;
};

/**
 * What Connie did while she worked, as affectUI Thinking State in live mode:
 * narration and thinking as steps, Library searches with their documents as
 * source chips, a live timer, then "Worked for Ns" folded away once the turn
 * ends. Live turns only; a reload has no notes to show.
 */
export function ConnieWorkingPanel({ message, isLive }: Props) {
  const steps = useMemo(() => buildWorkingSteps(message), [message]);
  const timing = useMemo(() => workingTiming(message), [message]);

  if (!steps.length && !isLive) return null;

  return (
    <div
      data-theme='dark'
      data-cy='connie-working-panel'
      className='connie-working-panel w-full min-w-0'
    >
      <ThinkingState
        live
        finished={!isLive}
        startedAt={timing.startedAt}
        durationMs={isLive ? undefined : timing.durationMs}
        collapseOnDone
        steps={steps}
        doneLabel='Answer ready'
      />
    </div>
  );
}
